import script from "./AssessmentRisk.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentRisk.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentRisk.vue?vue&type=style&index=0&id=5d27c471&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d27c471"]])

export default __exports__